var render = function render(){var _vm=this,_c=_vm._self._c;return _c('memlist-modal',{ref:"split-info-modal",attrs:{"title":_vm.title}},[_c('m-row',{staticClass:"p-8"},[_c('m-col',{staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(_vm.good_text))])],1),_c('m-row',{staticClass:"p-8"},[_c('m-col',{staticStyle:{"font-size":"18px","color":"red"}},[_vm._v(_vm._s(_vm.bad_text))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }